export const MULTI_TRIP = 'AnnualMultiTrip';
export const SINGLE_TRIP = 'SingleTrip';
